module.exports = __webpack_public_path__ + "static/tick-17e75ff122f76d3c3e679abbc5335386.png";